




























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteHospitaisStore from '@/components/Suporte/Store/SuporteHospitaisStore'
import { validateCNPJ, validateEmail, getUfs, validateGUID, generateGUID } from '@/utils/common'

@Component
export default class ComponentModalSuporteHospital extends Vue {
  $refs!: {
    formNovoHospital: any,
    imageUpload: any,
  }

  loadCep: boolean = false
  ufs: any[] = [...getUfs()]

  get loadingCep() { return this.loadCep }
  set loadingCep(value: boolean) { this.loadCep = value }

  formNovoHospitalRules: any = {
    valid: true,
    novoHospitalId: [(v: any) => this.validateNovoHospitalId(v)],
    razaoSocial: [(v: any) => !!v || 'Campo obrigatório'],
    nomeFantasia: [(v: any) => !!v || 'Campo obrigatório'],
    cnes: [(v: any) => this.validateCnes(v)],
    cnpj: [(v: any) => this.validateCnpj(v)],
    cep: [(v: any) => this.validateCep(v)],
    uf: [(v: any) => !!v || 'Campo obrigatório'],
    logradouro: [(v: any) => !!v || 'Campo obrigatório'],
    cidade: [(v: any) => !!v || 'Campo obrigatório'],
    bairro: [(v: any) => !!v || 'Campo obrigatório'],
    logo: [(v: any) => !!v || 'Campo obrigatório'],
    hospitalModeloId: [(v: any) => !!v || 'Campo obrigatório'],
    hisTipo: [(v: any) => !!v || 'Campo obrigatório'],
    contextoDB: [(v: any) => !!v || 'Campo obrigatório'],
    email: [(v: any) => this.validateEmailType(v)],
    emailAgendamento: [(v: any) => this.validateEmailType(v)],
  }

  validateNovoHospitalId(value) {
    if (['', null, undefined].includes(value)) return true
    if (!validateGUID(value)) return 'Formato inválido.'
    return false
  }

  validateCep(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    const cleanedValue = value.replace(/-/g, '')
    if (cleanedValue.length < 8) return 'CEP inválido.'
    return false
  }

  validateCnes(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    if (value.length < 8) return 'CNES inválido.'
    return false
  }

  validateCnpj(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    const cleanedValue = value.replace(/\./g, '').replace(/-/g, '').replace(/\//g, '')
    if (cleanedValue.length < 14) return 'CNPJ inválido.'
    if (cleanedValue.length === 14) return validateCNPJ(cleanedValue) || 'CNPJ inválido.'
    return false
  }

  validateEmailType(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    if (!validateEmail(value)) return 'E-mail inválido.'
    return false
  }

  keyToUpperCase(event: KeyboardEvent) {
    return String(event.key).toUpperCase()
  }

  get listaDeHospitaisId() {
    return this.getSuporteHospitaisStore.listaDeHospitais.map((hospital: any) => hospital.id)
  }

  async generateID() {
    let id = generateGUID()

    while (this.listaDeHospitaisId.includes(id)) {
      id = generateGUID()
    }

    await navigator.clipboard.writeText(id)
    this.getSuporteHospitaisStore.novoHospital.novoHospitalId = id
  }

  async findAddress(value) {
    if (['', null, undefined].includes(value.target.value) || value.target.length < 9) return
    this.loadingCep = true
    await this.getSuporteHospitaisStore.buscaCep()
    this.loadingCep = false
  }

  get getSuporteHospitaisStore() {
    return getModule(SuporteHospitaisStore, this.$store)
  }


  loadSaveOrUpdateHospital: boolean = false
  get loadingSaveOrUpdateHospital() { return this.loadSaveOrUpdateHospital }
  set loadingSaveOrUpdateHospital(value: boolean) { this.loadSaveOrUpdateHospital = value }

  get showModalHospital() { return this.getSuporteHospitaisStore.modal.hospital }
  set showModalHospital(value: boolean) { this.getSuporteHospitaisStore.setModal({ name: 'hospital', value }) }

  async saveOrUpdateHospital() {
    this.loadingSaveOrUpdateHospital = true

    if (this.$refs.formNovoHospital.validate()) {
      const { mode } = this.getSuporteHospitaisStore

      const response = await this.getSuporteHospitaisStore.criarHospitalUtilizandoModelo()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Hospital ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.showModalHospital = false
        // window.location.reload()
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o hospital ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateHospital = false
  }

  @Watch('showModalHospital')
  async onChangeShowModalHospital(value: boolean) {
    if (!value) {
      this.$refs.formNovoHospital.resetValidation()
      this.$refs.formNovoHospital.reset()
      this.getSuporteHospitaisStore.clearNovoHospital()
      this.getSuporteHospitaisStore.clearListaDeHospitais()
      this.$refs.imageUpload.clear()
      this.$refs.imageUpload.errors = []
      this.getSuporteHospitaisStore.setMode({ mode: 'CREATE' })
    }
  }
}
